import { FormattedMessage } from 'react-intl';

export const DeprecatedFeatureMessage = () => {
    return (
        <FormattedMessage
            id='platform.components.deprecated-feature-banner.message'
            description='Warning shown on deprecated admin pages and navigation links that will be removed in a future update'
            defaultMessage='This component will be removed in a future update. If you need this feature and do not have or know of any replacement contact our support. Together we can figure out how to resolve this.'
        />
    );
};

export default DeprecatedFeatureMessage;
